import React, { createContext, useState, ReactNode } from "react";

export interface ITableContextProps {
  gridColsClass: string;
  setGridColsClass: (gridColsClass: string) => void;
  hover: boolean;
  setHover: (hover: boolean) => void;
  sortable: boolean;
  setSortable: (sortable: boolean) => void;
}

const defaultTableContext: ITableContextProps = {
  gridColsClass: "grid-cols-12",
  setGridColsClass: () => {},
  hover: true,
  setHover: () => {},
  sortable: false,
  setSortable: () => {},
};

export const TableContext = createContext(defaultTableContext);

interface TableProviderProps {
  children: ReactNode;
}
export const TableProvider: React.FC<TableProviderProps> = ({ children }) => {
  const [gridColsClass, setGridColsClass] = useState(defaultTableContext.gridColsClass);
  const [hover, setHover] = useState(defaultTableContext.hover);
  const [sortable, setSortable] = useState(defaultTableContext.sortable);

  return (
    <TableContext.Provider value={{ gridColsClass, setGridColsClass, hover, setHover, sortable, setSortable }}>
      {children}
    </TableContext.Provider>
  );
};
